module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei8.svg";